module.exports = __webpack_public_path__ + "static/media/barbara6.f00bb97d.mp3";